import { CatalogItem } from "../../domain/catalogItem"
import { useDraggable } from "@dnd-kit/core"
import { useEffect, useState } from "react"
import { CatalogTemplateWithItems } from "../../domain/catalogTemplate"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGripDotsVertical } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  catalogItem?: CatalogItem
  template?: CatalogTemplateWithItems
}

const Grip = ({ catalogItem, template }: Props) => {
  const [dragCounter, setDragCounter] = useState(0)
  const { setNodeRef, setActivatorNodeRef, attributes, listeners, isDragging } = useDraggable({
    id: `${catalogItem?.guid ?? template?.id}:${dragCounter}`,
    data: { catalogItem, template }
  })

  useEffect(() => {
    if (!isDragging) {
      setDragCounter(d => d + 1)
    }
  }, [isDragging])

  return <div ref={setNodeRef} style={{ width: '20px' }}>
    <span ref={setActivatorNodeRef} {...attributes} {...listeners}>
      <FontAwesomeIcon icon={faGripDotsVertical} style={{ fontSize: 18, cursor: 'move' }}  />
    </span>
  </div>
}

export default Grip
